import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/banners',
		component: Base,
		children: [
			{
				path: '',
				name: 'BannersList',
				component: List,
				meta: {
					path: '/site/banners',
					pai: 'Site',
					title: 'Admin - Banners',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Banners',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'BannersNovo',
				component: Form,
				meta: {
					path: '/site/banners',
					pai: 'Site',
					title: 'Admin - Banners - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Banners',
						class: '',
						active: false,
						url: '/site/banners'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'BannersEditar',
				component: Form,
				meta: {
					path: '/site/banners',
					pai: 'Site',
					title: 'Admin - Banners - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Banners',
						class: '',
						active: false,
						url: '/site/banners'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]